const elements = {
  banner: document.body.querySelector('.js-banner-notification'),
  bannerCloseBtn: document.body.querySelector('.js-banner-notification-close'),
};

function closeBanner() {
  elements.banner.setAttribute('hidden', true);
}

function init() {
  if (!elements.bannerCloseBtn) {
    return;
  }

  elements.bannerCloseBtn.addEventListener('click', closeBanner);
}

export default init;
